import { useTranslation } from "react-i18next"
import {
  Button,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@nexus/ui"

export function PendingActions({
  disabled,
  isBusy,
  onReject,
  onAccept,
}: {
  disabled: boolean
  isBusy: boolean
  onReject: () => void
  onAccept: () => void
}) {
  const { t } = useTranslation()
  return (
    <TooltipProvider delayDuration={300}>
      <div className="flex flex-wrap items-center gap-2">
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              type="button"
              variant="outline"
              size="lg"
              className="min-w-0 flex-1 border-error/40 text-error hover:border-error/55 hover:bg-error-subtle hover:text-error"
              disabled={disabled}
              iconStart="x"
              onClick={onReject}
            >
              {t("personas.onboarding.review.reject", "Reject")}
            </Button>
          </TooltipTrigger>
          <TooltipContent>
            {t(
              "personas.onboarding.review.rejectTooltip",
              "Removes this persona from your library and records the rejection.",
            )}
          </TooltipContent>
        </Tooltip>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              type="button"
              size="lg"
              className="min-w-0 flex-1"
              disabled={disabled || isBusy}
              iconStart="check"
              onClick={onAccept}
            >
              {t("personas.onboarding.review.accept", "Accept")}
            </Button>
          </TooltipTrigger>
          <TooltipContent>
            {t(
              "personas.onboarding.review.acceptTooltip",
              "Adds this persona to your library so it can be used for Opportunities.",
            )}
          </TooltipContent>
        </Tooltip>
      </div>
    </TooltipProvider>
  )
}
